module.exports = __webpack_public_path__ + "img/2.8627bf2a.png";